<template>
  <div class="choice-box-overlay">
    <div class="choice-box">
      <h3 class="choice-title">{{ title }}</h3>
      <div class="choice-options">
        <button
          v-for="(choice, index) in choices"
          :key="index"
          class="choice-button"
          @click="selectChoice(choice)"
        >
          {{ choice.text }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ChoiceOption } from '../types';

defineProps<{
  title: string;
  choices: ChoiceOption[];
}>();

const emit = defineEmits<{
  (e: 'select', choice: ChoiceOption): void;
}>();

const selectChoice = (choice: ChoiceOption) => {
  emit('select', choice);
};
</script>

<style scoped>
.choice-box-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10003;
  pointer-events: auto;
}
.choice-box {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  width: 90%;
  max-width: 400px;
}
.choice-title {
  margin-top: 0;
  margin-bottom: 20px;
  text-align: center;
}
.choice-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.choice-button {
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background-color: #f0f0f0;
  cursor: pointer;
  transition: background-color 0.2s;
}
.choice-button:hover {
  background-color: #e0e0e0;
}
</style>
